module.exports = __webpack_public_path__ + "static/img/bg-es.f0327aa8.webp";